export const env = {
  evoEnvironment: import.meta.env.VITE_EVO_ENVIRONMENT,
  idpAuthority: import.meta.env.VITE_IDP_AUTHORITY,
  idpClientId: import.meta.env.VITE_IDP_CLIENT_ID,
  evoHostScript: import.meta.env.VITE_EVO_HOST_SCRIPT,
  mfeName: import.meta.env.VITE_MFE_NAME,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
};

export function assertEnv(): void {
  const missing = Object.entries(env)
    .filter(([, v]) => !v)
    .map(([k]) => k);
  if (missing.length) {
    throw new Error(`Missing env vars: ${missing.join(', ')}`);
  }
}
